import Main from "@/components/main/index.vue";

/*
 * meta:{
 *   showInSideMenu: 是否显示在左侧导航
 * }
 * */
export default [{
        path: "/login",
        name: "login",
        meta: {
            title: "登录"
        },
        component: () =>
            import ("@/views/login/login.vue")
    },
    {
        path: "/",
        name: "_home",
        redirect: "/group",
        component: Main,
        meta: {
            title: "首页"
                // hideInMenu: true,
                // notCache: true
        },
        children: [{
            path: "/home",
            name: "home",
            // redirect: "/group",
            meta: {
                title: "首页"
            },
            component: () => import ("@/views/Home.vue")
        }]
    },
    {
        path: "/group",
        name: "group",
        component: Main,
        redirect: "/group/group_page",
        meta: {
            title: "集团模块",
            // permissionId: "11",
            showInSideMenu: true
        },
        children: [{
            path: "group_page",
            name: "group_page",
            redirect: "/group/group_page/organize_structure",
            meta: {
                title: "集团管理",
                showInSideMenu: true
            },
            component: () =>
              import ("@/views/group/index.vue"),
            children: [{
                    path: "organize_structure",
                    name: "organize_structure",
                    meta: {
                        title: "组织结构"
                    },
                    component: () =>
                    import ("@/views/personnel/employee-info.vue")
                },
                {
                    path: "facility_system",
                    name: "facility_system",
                    meta: {
                        title: "设备设施系统"
                    },
                    component: () =>
                      import ("@/views/group/facility_system.vue")
                },{
                    path: "fault_type",
                    name: "fault_type",
                    meta: {
                        title: "故障类型"
                    },
                    component: () =>
                      import ("@/views/group/fault_type.vue")
                },
                {
                    path: "authority_manage",
                    name: "authority_manage",
                    meta: {
                        title: "权限管理"
                    },
                    component: () =>
                      import ("@/views/group/authority_manage.vue")
                }
            ]
        },
        {
            path: "info-manage",
            name: "info-manage",
            meta: {
                title: "部门管理"
            },
            component: () =>
              import ("@/views/personnel/info-manage.vue")
        }
        ]
    },
    {
        path: "/401",
        name: "error_401",
        meta: {},
        component: () =>
            import ("@/views/error-pages/401.vue")
    },
    {
        path: "/500",
        name: "error_500",
        meta: {},
        component: () =>
            import ("@/views/error-pages/500.vue")
    },
    {
        path: "*",
        name: "error_404",
        meta: {},
        component: () =>
            import ("@/views/error-pages/404.vue")
    }
];
